import React, { useEffect, useState } from "react";
import api from "../../services/api";
import { useNavigate } from "react-router-dom";

import PageHeader from "../components/PageHeader";
import SearchBar from "../components/SearchBar";
import DataTable from "../components/DataTable";
import Loader from "../components/Loader";
import ConfirmModal from "../components/ConfirmModal";
import API_URL from "../../config";

const Recruiters = () => {

    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);

    const [recruiters, setRecruiters] = useState([]);

    const [filteredRecruiters, setFilteredRecruiters] = useState([]);

    const [search, setSearch] = useState("");

    const [selectedRecruiter, setSelectedRecruiter] = useState(null);

    const [deleteId, setDeleteId] = useState(null);

    const [foundingId, setFoundingId] = useState(null);

    useEffect(() => {

        fetchRecruiters();

    }, []);

    useEffect(() => {

        filterRecruiters();

    }, [search, recruiters]);

    const fetchRecruiters = async () => {

        try {

            setLoading(true);

            const response = await api.get("/admin/recruiters");
            setRecruiters(response.data.data || []);
            setFilteredRecruiters(response.data.data || []);

        } catch (error) {

            console.error("Error fetching recruiters", error);

        } finally {

            setLoading(false);

        }

    };

    const filterRecruiters = () => {

        if (!search.trim()) {

            setFilteredRecruiters(recruiters);

            return;

        }

        const keyword = search.toLowerCase();

        const filtered = recruiters.filter((recruiter) =>

            recruiter.company_name?.toLowerCase().includes(keyword) ||

            recruiter.contact_person?.toLowerCase().includes(keyword) ||

            recruiter.email?.toLowerCase().includes(keyword) ||

            recruiter.phone?.includes(search)

        );

        setFilteredRecruiters(filtered);

    };

    const handleDelete = async () => {

        if (!deleteId) return;

        try {

            await api.delete(
                `${API_URL}/admin/recruiters/${deleteId}`
            );

            fetchRecruiters();

        } catch (error) {

            console.error("Delete failed", error);

        }

    };
    const handleGrantFounding = async () => {

    if (!foundingId) return;

    console.log("GRANT FOUNDING CLICKED:", foundingId);

    try {

        const response = await api.post(
            `/admin/recruiters/${foundingId}/founding`
        );

        console.log("GRANT FOUNDING RESPONSE:", response.data);

        alert("Founding Hospital access granted successfully.");

        setFoundingId(null);

        fetchRecruiters();

    } catch (error) {

        console.error("GRANT FOUNDING ERROR:", error);
        console.error("STATUS:", error.response?.status);
        console.error("DATA:", error.response?.data);

        alert(
            error.response?.data?.message ||
            "Failed to grant Founding Hospital access."
        );
    }
};

   const columns = [

    {
        key: "id",
        label: "ID"
    },

    {
        key: "company_name",
        label: "Company"
    },

    {
        key: "recruiter_name",
        label: "Contact Person"
    },

    {
        key: "email",
        label: "Email"
    },

    {
        key: "phone",
        label: "Phone"
    },

    {
        key: "city",
        label: "City"
    },

    {
        key: "active_plan_name",
        label: "Plan",
        render: (recruiter) => {

            if (!recruiter.active_plan_name) {

                return (
                    <span className="px-3 py-1 rounded-full bg-gray-100 text-gray-600 text-sm font-semibold">
                        Free
                    </span>
                );

            }

            return (
                <span className="px-3 py-1 rounded-full bg-teal-100 text-teal-700 text-sm font-semibold">
                    {recruiter.active_plan_name}
                </span>
            );

        }
    },

    {
        key: "founding_access",
        label: "Founding Access",
        render: (recruiter) => {

            if (recruiter.active_plan_code === "FOUNDING") {

                return (
                    <div>
                        <span className="px-3 py-1 rounded-full bg-teal-100 text-teal-700 text-sm font-semibold">
                            Active
                        </span>

                        {recruiter.subscription_expires_at && (
                            <div className="text-xs text-gray-500 mt-1">
                                Until{" "}
                                {new Date(
                                    recruiter.subscription_expires_at
                                ).toLocaleDateString("en-IN")}
                            </div>
                        )}
                    </div>
                );

            }

            if (recruiter.active_plan_code) {

                return (
                    <span className="px-3 py-1 rounded-full bg-gray-100 text-gray-500 text-sm font-semibold">
                        Not Applicable
                    </span>
                );

            }

            return (
                <span className="px-3 py-1 rounded-full bg-yellow-100 text-yellow-700 text-sm font-semibold">
                    Not Granted
                </span>
            );

        }
    }

];
        if (loading) {

        return (
            <Loader
                fullScreen={true}
                text="Loading Recruiters..."
            />
        );

    }

    return (

        <div className="space-y-6">

            <PageHeader
                title="Recruiters"
                subtitle="Manage all registered recruiters"
                showButton={false}
                breadcrumb={[
                    {
                        label: "Dashboard",
                        link: "/admin"
                    },
                    {
                        label: "Recruiters"
                    }
                ]}
            />

            <div className="bg-white rounded-3xl shadow-lg p-6">

    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">

        <SearchBar
            value={search}
            onChange={setSearch}
            onClear={() => setSearch("")}
            placeholder="Search recruiters..."
        />

    </div>

    <DataTable
        title="Recruiter List"
        columns={columns}
        data={filteredRecruiters}
        emptyMessage="No recruiters found."
        actions={(recruiter) => (

    <div className="flex justify-center gap-2 flex-wrap">

        <button
            onClick={() => setSelectedRecruiter(recruiter)}
            className="px-3 py-2 rounded-xl bg-blue-100 text-blue-600 hover:bg-blue-200 transition"
        >
            View
        </button>

        <button
            onClick={() =>
                navigate(`/admin/recruiters/edit/${recruiter.id}`)
            }
            className="px-3 py-2 rounded-xl bg-yellow-100 text-yellow-700 hover:bg-yellow-200 transition"
        >
            Edit
        </button>

               {(!recruiter.active_plan_code ||
    recruiter.active_plan_code === "FREE") && (
    <button
        onClick={() => setFoundingId(recruiter.id)}
        className="px-3 py-2 rounded-xl bg-teal-100 text-teal-700 hover:bg-teal-200 transition font-semibold"
    >
        Grant Founding
    </button>
)}

{recruiter.active_plan_code === "FOUNDING" && (
    <span className="px-3 py-2 rounded-xl bg-teal-600 text-white font-semibold">
        Founding Active
    </span>
)}
        <button
            onClick={() => setDeleteId(recruiter.id)}
            className="px-3 py-2 rounded-xl bg-red-100 text-red-600 hover:bg-red-200 transition"
        >
            Delete
        </button>

    </div>

)}
    />

</div>

            <ConfirmModal
    open={deleteId !== null}
    title="Delete Recruiter"
    message="Are you sure you want to delete this recruiter?"
    confirmText="Delete"
    onConfirm={() => {
        handleDelete();
        setDeleteId(null);
    }}
    onCancel={() => setDeleteId(null)}
/>
<ConfirmModal
    open={foundingId !== null}
    title="Grant Founding Hospital Access"
    message="Are you sure you want to grant Founding Hospital access to this recruiter? This will activate the Founding Hospital plan."
    confirmText="Grant Founding Access"
    onConfirm={async () => {
        await handleGrantFounding();
    }}
    onCancel={() => setFoundingId(null)}
/>
                    {selectedRecruiter && (

                <div
                    className="modal fade show"
                    style={{
                        display: "block",
                        backgroundColor: "rgba(0,0,0,0.5)"
                    }}
                >

                   {selectedRecruiter && (

<div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">

<div className="bg-white rounded-3xl shadow-2xl w-full max-w-4xl p-8">

<div className="flex justify-between items-center mb-8">

<h2 className="text-2xl font-bold">
Recruiter Details
</h2>

<button
onClick={() => setSelectedRecruiter(null)}
className="text-2xl text-gray-500 hover:text-red-500"
>
✕
</button>

</div>

<div className="grid grid-cols-1 md:grid-cols-2 gap-6">

<Detail label="Recruiter" value={selectedRecruiter.recruiter_name} />

<Detail label="Company" value={selectedRecruiter.company_name} />

<Detail label="City" value={selectedRecruiter.city} />

<Detail label="State" value={selectedRecruiter.state} />

<Detail label="Address" value={selectedRecruiter.address} />

<Detail label="Website" value={selectedRecruiter.website} />

<Detail label="About" value={selectedRecruiter.about} />

<div className="md:col-span-2">

<Detail
label="Description"
value={selectedRecruiter.description}
/>

</div>

</div>

<div className="flex justify-end mt-8">

<button
onClick={() => setSelectedRecruiter(null)}
className="px-5 py-2 rounded-xl bg-gray-200 hover:bg-gray-300"
>
Close
</button>

</div>

</div>

</div>

)}

                </div>

            )}

        </div>

    );

};
const Detail = ({ label, value }) => (
    <div>
        <p className="text-sm text-gray-500">{label}</p>
        <p className="font-semibold text-gray-800">
            {value || "-"}
        </p>
    </div>
);

export default Recruiters;